import React from 'react';
import { VscWorkspaceTrusted } from 'react-icons/vsc';

export default function Security() {
  return (
    <section className="lg:mt-36 w-full h-full min-h-screen">
      <div className="w-full flex flex-col items-start justify-start mt-10 lg:mt-20 max-w-7xl mx-auto px-8 sm:px-10">
        <div className="lg:h-[425px] flex flex-col w-full lg:flex-row items-start justify-between">
          <div className="mt-28 lg:w-2/3 flex flex-col items-start justify-start lg:pr-12">
          <div className=" flex items-center justify-center">
              {/* <Rating /> */}
              <VscWorkspaceTrusted />
              <h2 className="text-gray-200 ml-2">
                SOC 2 Type II Certified
              </h2>
            </div>
            <h1 className="text-white mt-10 font-bold  text-4xl sm:text-6xl text-start">
              Security and privacy at Mendable
            </h1>
            <p className="text-white my-4 max-w-lg sm:text-lg text-start">
            We take security and privacy very seriously at Mendable. Take a look at our security features below. 
            </p>
            
          </div>
          
        </div>
        <div>

        <div  className="mt-10 divide-y divide-gray-800">
          {/* Row */}
          <div className="py-8 first-of-type:pt-0 last-of-type:pb-0">
            <div>
              <div className="inline-flex text-2xl font-medium bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-purple-100 pb-6">
                Product Security
              </div>
            </div>
            <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-2">
                <div >
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-gray-50">Encryption in transit</h4>
                  </div>
                  <p className="text-sm text-gray-400">Mendable uses TLS 1.2 or higher everywhere data is transmitted over potentially insecure networks..</p>
                </div>
                <div >
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-gray-50">Penetration Testing</h4>
                  </div>
                  <p className="text-sm text-gray-400">Mendables engages with one of the best penetration testing firms in the industry, Oneleet, at least once a year. Email us to request a full report. </p>
                </div>
                <div >
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-gray-50">Vulnerability Scanning</h4>
                  </div>
                  <p className="text-sm text-gray-400">
                    Mendable uses automated vulnerability scanning tools to identify potential vulnerabilities in our applications and infrastructure.
                    </p>
                </div>
            </div>
          </div>
        </div>
        <div className="max-w-3xl pb-12 md:pb-20">
        
        {/* <p className="text-lg text-gray-300">{valueProps.description}</p> */}
      </div>

        <div  className="divide-y divide-gray-800">
          {/* Row */}
          <div className="py-8 first-of-type:pt-0 last-of-type:pb-0">
            <div>
              <div className="inline-flex text-2xl font-medium bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-purple-100 pb-6">
                Enterprise Security
              </div>
            </div>
            <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-2">
                <div >
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-gray-50">Endpoint protection</h4>
                  </div>
                  <p className="text-sm text-gray-400">
                    
                  All corporate devices are centrally managed and are equipped with device management software and anti-malware protection. Endpoint security alerts are monitored with 24/7/365 coverage. 
                  </p>
                </div>
                <div >
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-gray-50">Security education</h4>
                  </div>
                  <p className="text-sm text-gray-400">Mendable provides comprehensive security training to all employees upon onboarding and annually through educational modules through Vanta’s platform. </p>
                </div>
                <div >
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-gray-50">SSO</h4>
                  </div>
                  <p className="text-sm text-gray-400">
                    Mendable provides SSO features for enterprises to manage their users and access to Mendable.
                    </p>
                </div>
            </div>
          </div>
        </div>
        
    </div>
    <div className="max-w-3xl pb-12 md:pb-20">
        
        {/* <p className="text-lg text-gray-300">{valueProps.description}</p> */}
      </div>

   
        <div  className="divide-y divide-gray-800">
          {/* Row */}
          <div className="py-8 first-of-type:pt-0 last-of-type:pb-0">
            <div>
              <div className="inline-flex text-2xl font-medium bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-purple-100 pb-6">
                Frequently asked security questions
              </div>
            </div>
            <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-2">
                <div >
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-gray-50">What security frameworks is Mendable compliant with?</h4>
                  </div>
                  <p className="text-sm text-gray-400">
                    
                  Mendable is SOC 2 Type II compliant. Additionally, we will soon be making strides to become complaint in ISO 27K:2022 and GDPR.
                  </p>
                </div>
                <div >
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-gray-50">Where does my data go when it is ingested to Mendable?</h4>
                  </div>
                  <p className="text-sm text-gray-400">When you ingest your data into the Mendable ecosystem, it is stored on our database provider. However, your data is not used to train the underlying OpenAI models. OpenAI may hold onto conversation data for up to 30 days for content moderations purposes, however it will be subsequently deleted. </p>
                </div>
               
            </div>
          </div>
        </div>
    
      </div>
    </section>
  );
}
